import { useEffect } from "react";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { Route as RootRoute } from "./__root";
import { useAuth } from "../providers/auth-context";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/auth/callback",
  component: CallbackPage,
});

/**
 * Better-Auth は provider からのコールバックを `/api/auth/callback/{provider}` で受け、
 * 認証成功後は `callbackURL` (ここでは `/`) に直接リダイレクトする。
 * 本ルートは旧フロー互換のため残されており、session 確立済みならダッシュボードへ遷移する。
 */
function CallbackPage() {
  const { session, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (session) {
      void navigate({ to: "/" });
    } else {
      void navigate({ to: "/auth/login", search: { error: "no_session" } as { error: string } });
    }
  }, [session, loading, navigate]);

  return (
    <div className="max-w-md mx-auto mt-12 text-center space-y-4">
      <h1 className="text-xl font-semibold">ログイン処理中…</h1>
    </div>
  );
}
